import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom'
import { PopTheme, SpTheme } from 'ui-components'
import Error from './components/Error'
import OpponentPage from './pages/OpponentPage'
import PreCommitPage from './pages/PreCommitPage'
import ReadyPage from './pages/ReadyPage'
import SelectionPage from './pages/SelectionPage'
import SuccessPage from './pages/SuccessPage'
import getEnv from './utils/envUtils'
import { useFavicon } from './utils/useFavicon'

const { brand } = getEnv()

const App = () => {
  useFavicon()
  const { t } = useTranslation('repairshop')

  return (
    <ThemeProvider theme={brand === 'POP' ? PopTheme : SpTheme}>
      <Router>
        <React.Fragment>
          <CssBaseline />
          <OpponentPage>
            <Routes>
              <Route path={'/:uuid'} element={<SelectionPage />} />
              <Route
                path={'/:uuid/valinta/:selection'}
                element={<PreCommitPage />}
              />
              <Route path={'/:uuid/valmis'} element={<ReadyPage />} />
              <Route
                path={'/:uuid/korjaamo-valittu'}
                element={<SuccessPage />}
              />
              <Route
                path={'/virhe'}
                element={
                  <Error
                    imageBaseName={'notFound'}
                    title={t('error.invalid-link-title')}
                    text={t('error.invalid-link-text')}
                  />
                }
              />
              <Route
                path={'/:uuid/virhe'}
                element={
                  <Error
                    imageBaseName={'notFound'}
                    title={t('error.link-not-found-title')}
                    text={t('error.link-not-found-text')}
                  />
                }
              />
              <Route
                path={'/:uuid/virhe/muu'}
                element={
                  <Error
                    imageBaseName={'error'}
                    title={t('error.something-failed-title')}
                    text={t('error.something-failed-text')}
                    buttonText={t('error.something-failed-button') || undefined}
                  />
                }
              />
              <Route path="*" element={<Navigate to="/virhe" />} />
            </Routes>
          </OpponentPage>
        </React.Fragment>
      </Router>
    </ThemeProvider>
  )
}
export default App
